import { RootState } from '../../store';

export const getAIChatState = (state: RootState): boolean =>
  state?.aiChatData?.isAIChatOpen;

export const getAIChatContextId = (state: RootState): string | null =>
  state?.aiChatData?.aiChatContextId;

export const getAIChatHistory = (state: RootState): any[] =>
  state?.aiChatData?.aiChatHistory || [];

export const getAIChatLoading = (state: RootState): boolean =>
  state?.aiChatData?.aiChatLoading || false;

export const getAIChatError = (state: RootState): string | null =>
  state?.aiChatData?.aiChatError;
